<template lang="pug">
.loader
	.loader__square
	.loader__square
	//- span
	//- span
	//- span
	//- span
</template>

<script>
export default {
	name: "Loader"
}
</script>

<style lang="scss" scoped>
.loader {
	width: 120px;
	height: 120px;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translateX(-50%) translateY(-50%);
	&__square {
		width: 50%;
		height: 50%;
		position: absolute;
		mix-blend-mode: hue;
		&:first-child {
			top: 0;
			left: 0;
			background: $blue;
			animation: 2s slide infinite linear;
		}
		&:last-child {
			background: $red;
			top: 50%;
			left: 50%;
			animation: 2s slideInv infinite linear;
		}
	}
	// span {
	// 	position: absolute;
	// 	width: 50%;
	// 	height: 50%;
	// 	// background: rgba(1,1,1,0.25);
	// 	// background: transparent;
	// 	&:first-of-type {
	// 		top: 0;
	// 		left: 0;
	// 		mix-blend-mode: screen;
	// 	}
	// 	&:nth-of-type(2) {
	// 		top: 50%;
	// 		left: 0;
	// 		mix-blend-mode: saturation;
	// 	}
	// 	&:nth-of-type(3) {
	// 		top: 50%;
	// 		left: 50%;
	// 		mix-blend-mode: color-burn;
	// 	}
	// 	&:last-of-type {
	// 		top: 0;
	// 		left: 50%;
	// 		mix-blend-mode: difference;
	// 	}
	// }
}

@keyframes slide {
	0% {
		top: 0%;
		left: 0%;
	}
	25% {
		top: 50%;
		left: 0%;
	}
	50% {
		top: 50%;
		left: 50%;
	}
	75% {
		top: 0%;
		left: 50%;
	}
	100% {
		top: 0%;
		left: 0%;
	}
}
@keyframes slideInv {
	0% {
		top: 50%;
		left: 50%;
	}
	25% {
		top: 50%;
		left: 0%;
	}
	50% {
		top: 0%;
		left: 0%;
	}
	75% {
		top: 0%;
		left: 50%;
	}
	100% {
		top: 50%;
		left: 50%;
	}
}
</style>